module.exports = __webpack_public_path__ + "img/dk.c0cd6347.svg";